// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";
// import { useLoading } from "./LoadingContext";

// function CopyJDForm() {
//   const navigate = useNavigate();
//   const { id } = useParams(); // Get the job ID from the URL parameters

//   const [jobData, setJobData] = useState({
//     role: "",
//     description: "",
//     mandatory_skills: "",
//     optional_skills: "",
//     total_experience: "",
//     relevant_experience: "",
//     education: "",
//     location: "",
//     offered_CTC: "",
//   });

//   const { loading, setLoading } = useLoading();
//   const [error, setError] = useState(null);

//   const handleChange = (e) => {
//     setJobData({ ...jobData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     // Retrieve client ID and user ID from localStorage
//     const storedClient = localStorage.getItem("client");
//     const storedUser = localStorage.getItem("user_id");

//     const client_id = storedClient ? Number(storedClient) : null;
//     const user_id = storedUser ? Number(storedUser) : null;

//     // Debugging: Log retrieved values
//     console.log("Submitting JD with:", { client_id, user_id });

//     if (!client_id || !user_id) {
//       alert("Client ID or User ID is missing. Please log in again.");
//       return;
//     }

//     // Step 1: Check for duplicates by making a GET request
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/`
//       );

//       const existingJDs = response.data.data; // Adjust this based on your actual API response structure

//       const isDuplicate = existingJDs.some(
//         (jd) =>
//           jd.role === jobData.role &&
//           jd.description === jobData.description &&
//           jd.mandatory_skills === jobData.mandatory_skills &&
//           jd.total_experience === jobData.total_experience &&
//           jd.location === jobData.location
//       );

//       if (isDuplicate) {
//         alert("This JD already exists, try changing one field and add.");
//         return; // Prevent submission if duplicate
//       }
//     } catch (error) {
//       console.error("Error checking for duplicate JDs:", error);
//       alert("There was an error checking for duplicates. Please try again.");
//       return;
//     }

//     // Step 2: Proceed to submit the form if no duplicate found
//     const updatedJobData = {
//       ...jobData, // Prefilled fields from the GET request
//       client: client_id, // use dynamically retrieved client ID
//       created_by: user_id, // use dynamically retrieved user ID
//     };

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/`,
//         updatedJobData
//       );
//       // console.log("Response data:", response.data);
//       navigate("/jd_dashboard"); // Navigate to dashboard after successful creation
//     } catch (error) {
//       if (
//         error.response &&
//         error.response.data &&
//         error.response.data.message
//       ) {
//         alert(error.response.data.message); // Show the backend error message as an alert
//       } else {
//         console.error(error);
//         alert("Failed to create Job Description. Please check your inputs.");
//       }
//     }
//   };

//   useEffect(() => {
//     setLoading(true);
//     axios
//       .get(`${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/${id}/`)
//       .then((response) => {
//         const data = response.data;
//         setJobData({
//           role: data.role || "",
//           description: data.description || "",
//           mandatory_skills: data.mandatory_skills || "",
//           optional_skills: data.optional_skills || "",
//           total_experience: data.total_experience || "",
//           relevant_experience: data.relevant_experience || "",
//           education: data.education || "",
//           location: data.location || "",
//           offered_CTC: data.offered_CTC || "",
//         });
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error(error);
//         setError(error);
//         setLoading(false);
//       });
//   }, [id]);

//   if (loading) {
//     return (
//       <div
//         className="container d-flex justify-content-center align-items-center"
//         style={{ height: "100vh" }}
//       >
//         <div>
//           <div
//             className="spinner-border text-dark"
//             role="status"
//             style={{ width: "3rem", height: "3rem" }}
//           >
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//         <h3 className="text-center text-dark">Data is Fetching.... </h3>
//       </div>
//     );
//   }

//   if (error) {
//     return <div>Error: {error.message}</div>;
//   }

//   return (
//     <>
//       <NavbarForOnboardingForm />
//       <div className="container py-5">
//         <div className="row d-flex justify-content-center align-items-center h-100">
//           <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
//             <div className="card border border-dark bg-transparent text-dark">
//               <div
//                 className="card-header border-dark text-white"
//                 style={{ background: "#008cba" }}
//               >
//                 <h4 className="text-center font_header">
//                   Add JD Configurator Form
//                 </h4>
//               </div>
//               <div className="card-body">
//                 <form onSubmit={handleSubmit}>
//                   <div className="row">
//                     <div className="col-md-6 mb-2">
//                       <label className="form-label" htmlFor="role">
//                         Role
//                       </label>
//                       <input
//                         type="text"
//                         id="role"
//                         name="role"
//                         className="form-control border-dark text-dark"
//                         placeholder="Role"
//                         value={jobData.role}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6 mb-2">
//                       <label className="form-label" htmlFor="description">
//                         Description
//                       </label>
//                       <input
//                         type="text"
//                         id="description"
//                         className="form-control border-dark text-dark"
//                         placeholder="Description"
//                         name="description"
//                         value={jobData.description}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="row">
//                     <div className="col-md-6 mb-2">
//                       <label className="form-label" htmlFor="mandatory_skills">
//                         Mandatory Skills
//                       </label>
//                       <input
//                         type="text"
//                         id="mandatory_skills"
//                         className="form-control border-dark text-dark"
//                         name="mandatory_skills"
//                         value={jobData.mandatory_skills}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6 mb-2">
//                       <label htmlFor="optional_skills" className="form-label">
//                         Optional Skills
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="optional_skills"
//                         name="optional_skills"
//                         value={jobData.optional_skills}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="row">
//                     <div className="col-md-6 mb-2">
//                       <label htmlFor="total_experience" className="form-label">
//                         Total Experience
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="total_experience"
//                         name="total_experience"
//                         value={jobData.total_experience}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6 mb-2">
//                       <label
//                         htmlFor="relevant_experience"
//                         className="form-label"
//                       >
//                         Relevant Experience
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="relevant_experience"
//                         name="relevant_experience"
//                         value={jobData.relevant_experience}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="row">
//                     <div className="col-md-6 mb-2">
//                       <label htmlFor="education" className="form-label">
//                         Education
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="education"
//                         name="education"
//                         value={jobData.education}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6 mb-2">
//                       <label className="form-label" htmlFor="offered_ctc">
//                         Offered CTC
//                       </label>
//                       <input
//                         type="text"
//                         id="offered_CTC"
//                         name="offered_CTC"
//                         className="form-control border-dark text-dark"
//                         value={jobData.offered_CTC}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label htmlFor="location" className="form-label">
//                         Location
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="location"
//                         name="location"
//                         value={jobData.location}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="text-center py-2">
//                     <button type="submit" className="btn btn-outline-info me-3">
//                       Add JD
//                     </button>
//                     <button
//                       className="btn btn-outline-danger"
//                       type="button"
//                       onClick={() => navigate("/jd_dashboard")}
//                     >
//                       Close
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default CopyJDForm;

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";
import { useLoading } from "./LoadingContext";

function CopyJDForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { loading, setLoading } = useLoading();
  const [error, setError] = useState(null);

  const [jobData, setJobData] = useState({
    role: "",
    description: "",
    mandatory_skills: "",
    optional_skills: "",
    total_experience: "",
    relevant_experience: "",
    education: "",
    location: "",
    offered_CTC: "",
    mandatory_skills_weight: "",
    relevant_experience_weight: "",
    education_weight: "",
    location_weight: "",
    optional_skills_weight: "",
  });

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/${id}/`)
      .then((response) => {
        setJobData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setError(error);
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    setJobData({ ...jobData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/`,
        jobData
      );
      navigate("/jd_dashboard");
    } catch (error) {
      console.error(error);
      alert("Failed to create Job Description.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-5">
        <div className="row d-flex justify-content-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
            <div className="card border border-dark bg-transparent text-white">
              <div
                className="card-header border-dark text-white"
                style={{ background: "#008cba" }}
              >
                <h4 className="text-center font_header">
                  Add JD Configurator Form
                </h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit} className="text-dark">
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Role</label>
                      <input
                        type="text"
                        name="role"
                        className="form-control border-dark"
                        value={jobData.role}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        name="description"
                        className="form-control border-dark"
                        value={jobData.description}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label htmlFor="total_experience" className="form-label">
                        Total Experience
                      </label>
                      <input
                        type="text"
                        name="total_experience"
                        className="form-control border-dark"
                        value={jobData.total_experience}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label" htmlFor="offered_ctc">
                        Offered CTC
                      </label>
                      <input
                        type="text"
                        id="offered_CTC"
                        name="offered_CTC"
                        className="form-control border-dark text-dark"
                        value={jobData.offered_CTC}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label htmlFor="mandatory_skills" className="form-label">
                        Mandatory Skills
                      </label>
                      <input
                        type="text"
                        name="mandatory_skills"
                        className="form-control border-dark"
                        value={jobData.mandatory_skills}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label
                        htmlFor="mandatory_skills_weight"
                        className="form-label"
                      >
                        Weightage (%)
                      </label>
                      <input
                        type="number"
                        name="mandatory_skills_weight"
                        className="form-control border-dark"
                        value={jobData.mandatory_skills_weight}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label htmlFor="optional_skills" className="form-label">
                        Optional Skills
                      </label>
                      <input
                        type="text"
                        name="optional_skills"
                        className="form-control border-dark"
                        value={jobData.optional_skills}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label
                        htmlFor="optional_skills_weight"
                        className="form-label"
                      >
                        Weightage (%)
                      </label>
                      <input
                        type="number"
                        name="optional_skills_weight"
                        className="form-control border-dark"
                        value={jobData.optional_skills_weight}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label
                        htmlFor="relevant_experience"
                        className="form-label"
                      >
                        Relevant Experience
                      </label>
                      <input
                        type="text"
                        name="relevant_experience"
                        className="form-control border-dark"
                        value={jobData.relevant_experience}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label
                        htmlFor="relevant_experience_weight"
                        className="form-label"
                      >
                        Weightage (%)
                      </label>
                      <input
                        type="number"
                        name="relevant_experience_weight"
                        className="form-control border-dark"
                        value={jobData.relevant_experience_weight}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label htmlFor="education" className="form-label">
                        Education
                      </label>
                      <input
                        type="text"
                        name="education"
                        className="form-control border-dark"
                        value={jobData.education}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label htmlFor="education_weight" className="form-label">
                        Weightage (%)
                      </label>
                      <input
                        type="number"
                        name="education_weight"
                        className="form-control border-dark"
                        value={jobData.education_weight}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label htmlFor="location" className="form-label">
                        Location
                      </label>
                      <input
                        type="text"
                        name="location"
                        className="form-control border-dark"
                        value={jobData.location}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label htmlFor="location_weight" className="form-label">
                        Weightage (%)
                      </label>
                      <input
                        type="number"
                        name="location_weight"
                        className="form-control border-dark"
                        value={jobData.location_weight}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button type="submit" className="btn btn-outline-info">
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-danger ms-2"
                      onClick={() => navigate("/jd_dashboard")}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CopyJDForm;
